import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loader"}},[_c(VProgressCircular,{attrs:{"size":"80","indeterminate":"","color":"secondary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }